import React from "react";
import { motion } from "framer-motion";

const STATUS_MAP = {
  COMING_SOON: { label: "COMING SOON", cls: "bg-gold text-black" },
  LAUNCHING: { label: "LAUNCHING", cls: "bg-neon text-black" },
  LIVE: { label: "LIVE", cls: "bg-neon text-black" },
  PAUSED: { label: "PAUSED", cls: "bg-danger text-white" },
};

function Row({ label, value }) {
  const empty = value == null || value === "";
  return (
    <div className="flex items-center justify-between border-b border-charcoal py-2">
      <span className="font-mono text-xs uppercase tracking-wider text-dim">{label}</span>
      <span className={`font-mono text-xs font-bold ${empty ? "text-danger" : "text-cream"}`}>
        {empty ? "NOT DEPLOYED" : value}
      </span>
    </div>
  );
}

export default function ChainCard({ chain, accent = "neon" }) {
  const st = STATUS_MAP[chain.status] || STATUS_MAP.COMING_SOON;
  const isSol = chain.chainType === "solana";
  const ring = isSol ? "border-grape" : "border-neon";
  const testid = `chain-card-${chain.chainName.toLowerCase().replace(/\s+/g, "-")}`;

  return (
    <motion.div
      whileHover={{ y: -6 }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
      className="comic-card p-6 relative overflow-hidden"
      data-testid={testid}
    >
      <div className={`absolute -top-10 -right-10 w-32 h-32 rounded-full opacity-20 blur-2xl ${isSol ? "bg-grape" : "bg-neon"}`} />
      <div className="flex items-start justify-between">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-widest text-dim">
            {isSol ? "SVM · Cluster" : "EVM · Chain"}
          </p>
          <h3 className={`font-display font-900 text-2xl mt-1 ${isSol ? "text-grape" : "text-neon"}`}>
            {chain.chainName}
          </h3>
        </div>
        <span className={`tag !shadow-[3px_3px_0_#000] ${st.cls}`}>{st.label}</span>
      </div>

      <div className={`mt-5 border-l-3 ${ring} pl-4`}>
        <Row label="Token" value={chain.symbol} />
        <Row label={isSol ? "Mint" : "Contract"} value={isSol ? chain.mintAddress : chain.tokenAddress} />
        <Row label="DEX" value={chain.dexUrl} />
        <Row label="Explorer" value={chain.explorerUrl} />
        <Row label="Liquidity" value={chain.liquidityAddress} />
      </div>

      <p className="mt-4 font-mono text-[11px] text-dim">
        {isSol ? "Standard Solana token architecture." : "Standard ERC-20-compatible architecture."} No token
        deployed yet.
      </p>
    </motion.div>
  );
}
